import { GLC2O } from "../../data/OSSD/Grade10/GLC2O";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";


export default function GLC2OPage() {
    return (
        <div>
            <GradeCourseTemplate data={GLC2O} />
        </div>
    )
}